// Data
export const GET_DATA = "GET_DATA"
export const LOAD_DEFERRED = "LOAD_DEFERRED"
export const TIME_TRAVEL = "TIME_TRAVEL"
export const ERROR = 'ERROR'
export const UPDATE_QUEUE = 'UPDATE_QUEUE'
export const UPDATE_QUEUE_INDEX = 'UPDATE_QUEUE_INDEX'
export const INCREASE_QUEUE_INDEX = 'INCREASE_QUEUE_INDEX'
export const CLEAR_QUEUE_INDEX = 'CLEAR_QUEUE_INDEX'

// Preferences
export const UPDATE_PREFERENCES = 'UPDATE_PREFERENCES'

// Side
export const SET_SIDE = 'SET_SIDE'

// Input
export const SET_INPUT = 'SET_INPUT'
export const SET_WINDOW = 'SET_WINDOW'

// Modal
export const SET_MODAL = 'SET_MODAL'
export const SET_SEC_MODAL = 'SET_SEC_MODAL'

// Toasts
export const SET_TOASTS = 'SET_TOASTS'

// Access
export const SET_ACCESS = 'SET_ACCESS'

// Data
export const UPDATE_DATA = 'UPDATE_DATA'
export const COMMIT_DATA = 'COMMIT_DATA' // Same as UPDATE_DATA but cannot undo/redo
export const UPDATE_ALERTS = 'UPDATE_ALERTS'


// Item
export const CREATE_ITEM = 'CREATE_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'
export const COMMIT_DND = 'COMMIT_DND'
export const CHANGE_ITEM_STATUS = 'CHANGE_ITEM_STATUS'

// Section
export const CREATE_SECTION = 'CREATE_SECTION'
export const UPDATE_SECTION = 'UPDATE_SECTION'
export const DELETE_SECTION = 'DELETE_SECTION'

// Page
export const CREATE_PAGE = 'CREATE_PAGE'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const DELETE_PAGE = 'DELETE_PAGE'

// Tag
export const CREATE_TAG = 'CREATE_TAG'
export const UPDATE_TAG = 'UPDATE_TAG'
export const DELETE_TAG = 'DELETE_TAG'

// Authentication
export const AUTH_START = "AUTH_START"
export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const AUTH_FAIL = "AUTH_FAIL"
export const AUTH_CANCEL = "AUTH_CANCEL"
export const AUTH_RESET = "AUTH_RESET"
export const SIGN_UP = "SIGN_UP"
export const SIGN_IN = "SIGN_IN"
export const SIGN_OUT = "SIGN_OUT"
export const SIGN_IN_THIRD_PARTY = 'SIGN_IN_THIRD_PARTY'
export const SIGN_IN_GOOGLE = "SIGN_IN_GOOGLE"
export const SIGN_IN_FACEBOOK = "SIGN_IN_FACEBOOK"
export const SIGN_IN_EXISTING = "SIGN_IN_EXISTING"
export const REAUTHENTICATE = 'REAUTHENTICATE'
export const SETUP_COMPLETE = 'SETUP_COMPLETE'

export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const EDIT_EMAIL = 'EDIT_EMAIL'
export const EDIT_STAGE = 'EDIT_STAGE'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const UPDATE_USER = 'UPDATE_USER'
export const USER_COUNT = 'USER_COUNT'

// DND
export const LIST_VIEW_START = "LIST_VIEW_START"
export const LIST_VIEW_END = "LIST_VIEW_END"
export const LIST_VIEW_HOVER = "LIST_VIEW_HOVER"
export const LIST_VIEW_DROP = "LIST_VIEW_HOVER"
export const LIST_VIEW_RESET = "LIST_VIEW_RESET"

// DB
export const GET_DATA2 = "GET_DATA2"
export const GET_ITEMS = "GET_ITEMS"
export const GET_SECTIONS = "GET_SECTIONS"
export const GET_PAGES = "GET_PAGES"
export const CREATE_ITEM2 = "CREATE_ITEM2"

// FOCUS
export const GET_FOCUS = "GET_FOCUS"
export const CREATE_FOCUS = "CREATE_FOCUS"
export const UPDATE_FOCUS = "UPDATE_FOCUS"

// SCHEDULE
export const GET_SCHEDULE = "GET_SCHEDULE"
export const CREATE_SCHEDULE = "CREATE_SCHEDULE"
export const UPDATE_SCHEDULE = "UPDATE_SCHEDULE"
export const FORWARD_SCHEDULE = "FORWARD_SCHEDULE"

// FILES
export const UPLOAD_FILE = "UPLOAD_FILE"
export const UPLOAD_ERROR = "UPLOAD_ERROR"
export const UPLOAD_RESET = "UPLOAD_RESET"

// INEGRATIONS
export const UPDATE_WORKFLOWS = 'UPDATE_WORKFLOWS'
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS'

// PAYMENTS
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT'
export const UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD'
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const UPDATE_INVOICES = 'UPDATE_INVOICES'